<template>
  <div class="content">
    <el-row style="height: 4vh; padding-left: 0.5vw; padding-top: 0.1vh;">
       <el-col :span="24" style="margin:0;display:flex;justify-content: space-between;">
        <div class="grid-content1 bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>安全巡查</el-breadcrumb-item>
            <el-breadcrumb-item>预警统计</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div>
          <el-button type="primary" size="mini">参数设置</el-button>
          <el-button type="primary" size="mini">历史数据</el-button>
        </div>
      </el-col>
    </el-row>

    <div class="main">
      <div class="main-top">
        <div class="main-top-1">
           <div style="display: flex;justify-content: space-between;">
              <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">实时数据</p></div>
              <div style="color: #0b62f0;font-size: 0.9vw;">3分钟前更新</div>
           </div>
           <div class="warn">
             <div class="warn-left">
                <div class="warn-item">
                  <span>安全文明预警</span>
                  <span style="margin-top: 0.8vh;">{{warm.safeWarmming}}</span>
                </div>
                <div class="warn-item">
                  <span>力矩预警</span>
                  <span style="margin-top: 0.8vh;">{{warm.angleWarmming}}</span>
                </div>
                <div class="warn-item">
                  <span>高度预警</span>
                  <span style="margin-top: 0.8vh;">{{warm.heightWarmming}}</span>
                </div>
                <div class="warn-item">
                  <span>质量预警</span>
                  <span style="margin-top: 0.8vh;">{{warm.qualityWarmming}}</span>
                </div>
             </div>
             <div class="warn-right">
                 <div ref="chart1" style="width: 100%;height: 100%;"></div>
             </div>
           </div>
            
        </div>
        <div class="main-top-2">
           <div style="display: flex;">
             <div style="display: flex;align-items: center;">
               <span class="circle"></span><p style="font-size: 1.1vw">周数据</p>
             </div>
             <div style="width:15vw;border:1px solid #ddd;display: flex;align-content: center;align-items: center;padding:0 0.5vw;margin-left: 5vw;">
                    <div style="width:2.5vw;height:100%;display: flex;align-items: center;cursor: pointer;" @click="preWeek"><i class="el-icon-arrow-left" style=""></i></div>
                    <p style="flex:1;">
                      <span class="nowrap" :title="weekstart + ' ~ ' +weekEnd" style="display: inline-block;width:100%;">{{weekstart + ' ~ ' +weekEnd}}</span>
                    </p>
                     <div style="width:2.5vw;height:100%;display: flex;align-items: center;cursor: pointer;" @click="nextWeek"><i class="el-icon-arrow-right"></i></div>
                  </div>
           </div>
           <div ref="chart2" style="width: 94%;height: 100%;"></div>
        </div>
      </div>

      <div class="main-bottom">
         <div style="display: flex;align-items: center;"><span class="circle"></span><p style="font-size: 1.1vw">预警统计</p></div>
         <div class="count-item">
           <div class="item-title">安全文明预警</div>
           <div class="item-wrap">
             <div style="height: 100%;width: 90%">
               <div class="item-flex top">
                 <span>处理状态</span>
                 <span>发生设备</span>
                 <span>发生时间</span>
                 <span>处理人</span>
                 <span>处理方式</span>
                 <span>处理信息</span>
                 <span>项目负责人</span>
                 <span>联系方式</span>
               </div>
               <template v-if="safe.length">
                <div class="item-flex bottom" v-for="item in safe" :key="item.id">
                    <span>
                      <span style="color:#E6A23C;" v-if="item.processStatus=='0'">待处理</span>
                      <span style="color:#4B7FCD;" v-else>已处理</span>
                    </span>
                    <span>{{item.channelName || '--'}}</span>
                    <span>{{item.happenDate || '--'}}</span>
                    <span>{{item.handlerName||'--'}}</span>
                    <span>{{item.processMode||'--'}}</span>
                    <span>{{item.handlerMsg||'--'}}</span>
                    <span>{{item.projectEnt.name||'--'}}</span>
                    <span>{{item.projectEnt.phone||'--'}}</span>
                </div>
               </template>
               <div v-else style="height: 8vh;border-right: 1px solid #e7e7e7;line-height: 8vh;">暂无数据</div>
             </div>
             <div style="display: flex;align-items: center;justify-content: center;width:10%;color: #2e5be9;">详情查看</div>
           </div>
         </div>
         <div class="count-item">
           <div class="item-title">力矩预警</div>
           <div class="item-wrap">
             <div style="height: 100%;width: 90%">
               <div class="item-flex top">
                <span>处理状态</span>
                 <span>发生设备</span>
                 <span>发生时间</span>
                 <span>处理人</span>
                 <span>处理方式</span>
                 <span>处理信息</span>
                 <span>项目负责人</span>
                 <span>联系方式</span>
               </div>
               <template v-if="angle.length">
                  <div class="item-flex bottom" v-for="item in angle" :key="item.id">
                 <span>
                     <span style="color:#E6A23C;" v-if="item.processStatus=='0'">待处理</span>
                     <span style="color:#4B7FCD;" v-else>已处理</span>
                 </span>
                 <span>{{item.channelName || '--'}}</span>
                 <span>{{item.happenDate || '--'}}</span>
                 <span>{{item.handlerName||'--'}}</span>
                 <span>{{item.processMode||'--'}}</span>
                 <span>{{item.handlerMsg||'--'}}</span>
                 <span>{{item.projectEnt.name||'--'}}</span>
                 <span>{{item.projectEnt.phone||'--'}}</span>
               </div>
               </template>
               <div v-else style="height: 8vh;border-right: 1px solid #e7e7e7;line-height: 8vh;">暂无数据</div>
             </div>
             <div style="display: flex;align-items: center;justify-content: center;width:10%;color: #2e5be9;">详情查看</div>
           </div>
         </div>
          <div class="count-item">
           <div class="item-title">高度限位预警</div>
           <div class="item-wrap">
             <div style="height: 100%;width: 90%">
               <div class="item-flex top">
                <span>处理状态</span>
                 <span>发生设备</span>
                 <span>发生时间</span>
                 <span>处理人</span>
                 <span>处理方式</span>
                 <span>处理信息</span>
                 <span>项目负责人</span>
                 <span>联系方式</span>
               </div>
               <template v-if="height.length">
                  <div class="item-flex bottom" v-for="item in height" :key="item.id">
                    <span>
                        <span style="color:#E6A23C;" v-if="item.processStatus=='0'">待处理</span>
                        <span style="color:#4B7FCD;" v-else>已处理</span>
                    </span>
                    <span>{{item.channelName || '--'}}</span>
                    <span>{{item.happenDate || '--'}}</span>
                    <span>{{item.handlerName||'--'}}</span>
                    <span>{{item.processMode||'--'}}</span>
                    <span>{{item.handlerMsg||'--'}}</span>
                    <span>{{item.projectEnt.name||'--'}}</span>
                    <span>{{item.projectEnt.phone||'--'}}</span>
                  </div>
               </template>
               <div v-else style="height: 8vh;border-right: 1px solid #e7e7e7;line-height: 8vh;">暂无数据</div>
             </div>
             <div style="display: flex;align-items: center;justify-content: center;width:10%;color: #2e5be9;">详情查看</div>
           </div>
         </div>
          <div class="count-item">
           <div class="item-title">质量预警</div>
           <div class="item-wrap">
             <div style="height: 100%;width: 90%">
               <div class="item-flex top">
                <span>处理状态</span>
                 <span>发生设备</span>
                 <span>发生时间</span>
                 <span>处理人</span>
                 <span>处理方式</span>
                 <span>处理信息</span>
                 <span>项目负责人</span>
                 <span>联系方式</span>
               </div>
              <template v-if="quality.length">
                 <div class="item-flex bottom" v-for="item in quality" :key="item.id">
                 <span>
                     <span style="color:#E6A23C;" v-if="item.processStatus=='0'">待处理</span>
                     <span style="color:#4B7FCD;" v-else>已处理</span>
                 </span>
                 <span>{{item.channelName || '--'}}</span>
                 <span>{{item.happenDate || '--'}}</span>
                 <span>{{item.handlerName||'--'}}</span>
                 <span>{{item.processMode||'--'}}</span>
                 <span>{{item.handlerMsg||'--'}}</span>
                 <span>{{item.projectEnt.name||'--'}}</span>
                 <span>{{item.projectEnt.phone||'--'}}</span>
               </div>
              </template>
              <div v-else style="height: 8vh;border-right: 1px solid #e7e7e7;line-height: 8vh;">暂无数据</div>
             </div>
             <div style="display: flex;align-items: center;justify-content: center;width:10%;color: #2e5be9;">详情查看</div>
           </div>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
  import util from '../../untils/util'
  import myHttp from '../../untils//port'
  export default {
    data() {
      return {
        params: {
          projectId: '',
          startDate: util.myTime.getNowFormatDate(new Date()),
          endDate: util.myTime.getNowFormatDate(new Date())
        },
        warm: {
          qualityWarmming: 0,    //质量预警
          safeWarmming: 0,   //安全预警
          heightWarmming: 0,   //高度预警
          angleWarmming: 0  // 力矩预警
        },
        safe: [],
        quality: [],
        height: [],
        angle: [],
        weekstart:'',
        weekEnd:'',
        timeOutFun: undefined,
        week: [],
        safeData: [],
        qualityData: [],
        heightData: [],
        angleData: []
      }
    },
    mounted() {
      const curWeek = util.myTime.getCurWeek()
      this.weekstart = curWeek[0]
      this.weekEnd = curWeek[1]
      this.params.projectId = util.session.get('groupId')
      this.getCount()
      this.getCountWeek()
      this.getData()
    },
    computed:{
      warmTotal(){
        return this.warm.qualityWarmming + this.warm.safeWarmming + this.warm.heightWarmming + this.warm.angleWarmming || '0'
      }
    },
    methods: {
      //  获取预警统计
      getCount(){
        myHttp.getChartByProjectIdCount(this.params).then(resp => {
          if(resp.data.code == '200'){
            const data = resp.data.data
            this.warm.qualityWarmming = data.qualityWarmming || 0
            this.warm.safeWarmming = data.safeWarmming || 0
            this.warm.heightWarmming = data.heightWarmming || 0
            this.warm.angleWarmming = data.angleWarmming || 0
            this.initChart1()
            if(this.timeOutFun){
              window.clearTimeout(this.timeOutFun)
            }
            this.timeOutFun = setTimeout(()=>{
              this.getCount()
            },180000)
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },

       //  获取周预警统计
      getCountWeek(){
        myHttp.getChartByProjectIdCountWeek({
          projectId: this.params.projectId,
          startDate: this.weekstart,
          endDate: this.weekEnd
        }).then(resp => {
          console.log(resp);
          if(resp.data.code == '200'){
            const data = resp.data.data
            let week = []
            // 保证week有值
            if(data.angleWarmming.length){
              for(let i=0;i<data.angleWarmming.length;i++){
                week.push(data.angleWarmming[i].clickDate.slice(5))
              }
            }else if(data.qualityWarmming.length){
              for(let i=0;i<data.qualityWarmming.length;i++){
                week.push(data.qualityWarmming[i].clickDate.slice(5))
              }
            }else if(data.safeWarmming){
              for(let i=0;i<data.safeWarmming.length;i++){
                week.push(data.safeWarmming[i].clickDate.slice(5))
              }
            }
            this.week = week
            // 安全
            for(let i = 0;i<data.safeWarmming.length;i++){
              this.safeData.push(data.safeWarmming[i].count)
            }
            //  质量
             for(let i = 0;i<data.qualityWarmming.length;i++){
              this.qualityData.push(data.qualityWarmming[i].count)
            }
            // 高度
             for(let i = 0;i<data.heightWarmming.length;i++){
              this.heightData.push(data.heightWarmming[i].count)
            }
            //  力矩
             for(let i = 0;i<data.angleWarmming.length;i++){
              this.angleData.push(data.angleWarmming[i].count)
            }
            this.initChart2()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },

      // 获取结果
      getData(){
        myHttp.getChartByProjectIdList({
          projectId: util.session.get('groupId')
        }).then(resp => {
          if(resp.data.code == '200'){
            this.safe = resp.data.data.safeWarmming || []
            this.quality = resp.data.data.qualityWarmming || []
            this.height = resp.data.data.heightWarmming || []
            this.angle = resp.data.data.angleWarmming || []
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },

      //获取上周时间
      preWeek(){
        var date= util.myTime.getPrevWeek(this.weekstart)
        this.weekstart = date[0]
        this.weekEnd = date[1]
        this.getCountWeek()
      },
      //获取下周时间
      nextWeek(){
        var date= util.myTime.getNextWeek(this.weekEnd)
        this.weekstart = date[0]
        this.weekEnd = date[1]
        this.getCountWeek()
      },



      // 预警统计 -- 实时数据
      initChart1(){
        let myChart = this.$echarts.init(this.$refs.chart1)
        myChart.setOption({
          title: {     // 设置标题在中间
            text: '预警总数',
            subtext: this.warmTotal,
            x: 'center',
            y: 'center',
            textStyle: {
              fontWeight: 'normal'
            },
            subtextStyle: {
              fontSize: '16',
              color: '#d81e06'
            }
          },
          series: [
            {
              type: 'pie',
              radius: ['50%', '75%'],
              color: ['#d81e06', '#d81e06', '#80b8e6','#d81e06'],
              itemStyle: {
                borderWidth: 3,      // 间距
                borderColor: '#fff'
              },
              data: [
                {
                  value: this.warm.angleWarmming,
                  name: `力矩预警\n${this.warm.angleWarmming}`
                },
                {
                  value: this.warm.heightWarmming,
                  name: `高度预警\n${this.warm.heightWarmming}`
                },
                {
                  value: this.warm.qualityWarmming,
                  name: `质量预警\n${this.warm.qualityWarmming}`
                },
                {
                  value: this.warm.safeWarmming,
                  name: `安全文明预警\n${this.warm.safeWarmming}`
                }
              ]
            }
          ]
        })
         window.addEventListener("resize", () => {
          myChart.resize();
        });
      },
      // 预警统计 -- 周数据
      initChart2(){
        let myChart = this.$echarts.init(this.$refs.chart2)
        myChart.setOption({
          xAxis: {
            data: this.week,
            boundaryGap: false,    // x轴两边不留空白
          },
          yAxis: {
            type: 'value'
          },
          legend: {
            orient: 'vertical',
            top: 0,
            right: 0
          },
          color: ['#1669f1', '#1669f1', '#0bf0e3', '#59378c'],
          series: [
            {
              name: '安全文明预警',
              type: 'line',
              symbolSize: 10,   //设置圆点的大小
              data: this.safeData
            },
            {
              name: '力矩预警',
              type: 'line',
              symbolSize: 10,   //设置圆点的大小
              data: this.angleData
            },
            {
              name: '高度预警',
              type: 'line',
              symbolSize: 10,   //设置圆点的大小
              data: this.heightData
            },
            {
              name: '质量预警',
              type: 'line',
              symbolSize: 10,   //设置圆点的大小
              data: this.qualityData
            }
          ]
        })
         window.addEventListener("resize", () => {
          myChart.resize();
        });
      }
    },
    beforeDestroy(){
      if(this.timeOutFun){
        window.clearTimeout(this.timeOutFun)
      }
    }
  }
</script>

<style scoped>
.circle{
  display: block;
  width: 1.2vh;
  height: 1.2vh;
  border-radius: 50%;
  background-color: #0B62F0;
  margin-right: 1vw;
}
.grid-content1 {
  font-size: 1.6vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 4px;
}
.main{
  margin-top: 1vh;
}
.main-top{
  height: 40vh;
  display: flex;
}
.main-bottom{
  height: 44vh;
  margin-top: 1vh;
  box-sizing: border-box;
  padding: 1vh 1vw;
  background-color: #ffffff;
	box-shadow: 0px 3px 10px 0px rgba(105, 159, 204, 0.5);
	border-radius: 6px;
  overflow: auto;
}
.main-top-1{
  width: 55%;
  height: 100%;
  padding: 1vh 1vw;
  box-sizing: border-box;
  background-color: #ffffff;
	box-shadow: 2px 2px 10px 0px rgba(105, 159, 204, 0.5);
	border-radius: 6px;
  margin-right: 0.4vw;
}
.main-top-2{
  width: 45%;
  height: 100%;
  padding: 1vh 1vw;
  box-sizing: border-box;
  background-color: #ffffff;
	box-shadow: 2px 2px 10px 0px rgba(105, 159, 204, 0.5);
	border-radius: 6px;
}
.warn{
  height: calc(100% - 3vh);
  display: flex;
}
.warn-left{
  width: 40%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  padding: 2vh 0;
  justify-content: space-around;
  align-content: space-around;
}
.warn-right{
  width: 60%;
  height: 100%;
}
.warn-item{
  display: flex;
  width: 40%;
  height: 10vh;
  background-color: #e7e7e7;
	border-radius: 6px;
	border: solid 2px #bdbdbd;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.count-item{
  margin-top: 1vh;
  width: 100%;
  /* height: 20vh; */
  box-shadow: 0px 3px 10px 0px 	rgba(105, 159, 204, 0.5)
}
.item-title{
  height: 5vh;
  margin: 0 auto;
  letter-spacing: 10px;
	color: #333333;
  font-size: 24px;
  line-height: 5vh;
  border-bottom: 1px solid #e7e7e7;
}
.item-wrap{
  display: flex;
  height: calc(100% - 5vh);
}
.item-header{
  height: 50%;
  width: 5vw;
  border-bottom: 1px solid #e7e7e7;
}
.item-body{
  height: 50%;
}
.item-flex{
  display: flex;
  height: 8vh;
  border-bottom: 1px solid #e7e7e7;
}
.item-flex > span {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #e7e7e7;
}
.top > span{
  color: #333;
}
.bottom > span {
  color: #666;
}
</style>